import Awesomplete from 'awesomplete';
import 'awesomplete/awesomplete.base.css';

export function getSearchAutocompletion(input, toggleButton, completions)
{
    let autocompletion = new Awesomplete(input, {
        list: completions,
        autoFirst: true,
        minChars: 0,
        maxItems: 100,
    });

    let toggleButtonClickFunc = () => {
        if (autocompletion.opened) {
            autocompletion.close();
        }
        else {
            autocompletion.evaluate();
            autocompletion.open();

            input.focus();
        }
    };
    toggleButton.addEventListener('click', toggleButtonClickFunc);

    input.addEventListener('awesomplete-close', () => {
        toggleButton.removeEventListener('click', toggleButtonClickFunc);
        setTimeout(() => {
            toggleButton.addEventListener('click', toggleButtonClickFunc);
        }, 500);
    });

    input.addEventListener('awesomplete-open', () => {
        toggleButton.classList.add('enhanced-input-dropdown-btn-expanded');
    });
    input.addEventListener('awesomplete-close', () => {
        toggleButton.classList.remove('enhanced-input-dropdown-btn-expanded');
    });

    input.addEventListener('focus', () => {
        autocompletion.evaluate();
        autocompletion.open();
    });

    toggleButton.addEventListener('click', () => {
        toggleButton.blur();
    });

    return autocompletion;
}
